"use strict";

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var eth_connect_1 = require("eth-connect");

var Blocks = /*#__PURE__*/function () {
  function Blocks(requestManager) {
    var save = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, Blocks);

    this.requestManager = requestManager;
    this.checkedBlocks = {};
    this.saveBlocks = save;

    if (save) {
      this.savedBlocks = {};
    }

    this.requests = 0;
  }

  _createClass(Blocks, [{
    key: "fillBlockTime",
    value: function () {
      var _fillBlockTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var latest, first;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getBlockWrapper('latest');

              case 2:
                latest = _context.sent;
                _context.next = 5;
                return this.getBlockWrapper(1);

              case 5:
                first = _context.sent;
                this.blockTime = (latest.timestamp - first.timestamp) / Number(latest.number) - 1;
                this.firstTimestamp = first.timestamp;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fillBlockTime() {
        return _fillBlockTime.apply(this, arguments);
      }

      return fillBlockTime;
    }()
  }, {
    key: "getDate",
    value: function () {
      var _getDate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(date) {
        var after,
            dateInSeconds,
            now,
            predictedBlock,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                after = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
                dateInSeconds = date / 1000;
                now = Date.now() / 1000;

                if (!(typeof this.firstTimestamp === 'undefined' || typeof this.blockTime === 'undefined')) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 6;
                return this.fillBlockTime();

              case 6:
                if (!(dateInSeconds < this.firstTimestamp)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", {
                  block: 1,
                  timestamp: dateInSeconds
                });

              case 8:
                if (!(dateInSeconds >= now || dateInSeconds > this.savedBlocks['latest'].timestamp)) {
                  _context2.next = 16;
                  break;
                }

                _context2.t0 = (0, eth_connect_1.toBigNumber);
                _context2.next = 12;
                return this.requestManager.eth_blockNumber();

              case 12:
                _context2.t1 = _context2.sent;
                _context2.t2 = (0, _context2.t0)(_context2.t1).toNumber();
                _context2.t3 = dateInSeconds;
                return _context2.abrupt("return", {
                  block: _context2.t2,
                  timestamp: _context2.t3
                });

              case 16:
                this.checkedBlocks[dateInSeconds] = [];
                _context2.next = 19;
                return this.getBlockWrapper(Math.ceil((dateInSeconds - this.firstTimestamp / this.blockTime) / 1000));

              case 19:
                predictedBlock = _context2.sent;
                _context2.next = 22;
                return this.findBetter(dateInSeconds, predictedBlock, after);

              case 22:
                _context2.t4 = _context2.sent;
                _context2.t5 = dateInSeconds;
                return _context2.abrupt("return", {
                  block: _context2.t4,
                  timestamp: _context2.t5
                });

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getDate(_x) {
        return _getDate.apply(this, arguments);
      }

      return getDate;
    }()
  }, {
    key: "findBetter",
    value: function () {
      var _findBetter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(date, predictedBlock, after) {
        var blockTime,
            difference,
            skip,
            nextPredictedBlock,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                blockTime = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : this.blockTime;
                _context3.next = 3;
                return this.isBetterBlock(date, predictedBlock, after);

              case 3:
                if (!_context3.sent) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", predictedBlock.number);

              case 5:
                difference = date - predictedBlock.timestamp;
                skip = Math.ceil(difference / blockTime);

                if (skip === 0) {
                  skip = difference < 0 ? -1 : 1;
                }

                _context3.next = 10;
                return this.getBlockWrapper(this.getNextBlock(date, predictedBlock.number, skip));

              case 10:
                nextPredictedBlock = _context3.sent;
                blockTime = Math.abs((predictedBlock.timestamp - nextPredictedBlock.timestamp) / (predictedBlock.number - nextPredictedBlock.number));
                return _context3.abrupt("return", this.findBetter(date, nextPredictedBlock, after, blockTime));

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function findBetter(_x2, _x3, _x4) {
        return _findBetter.apply(this, arguments);
      }

      return findBetter;
    }()
  }, {
    key: "isBetterBlock",
    value: function () {
      var _isBetterBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(date, predictedBlock, after) {
        var blockTime, previousBlock, nextBlock;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                blockTime = predictedBlock.timestamp;

                if (!after) {
                  _context4.next = 11;
                  break;
                }

                if (!(blockTime < date)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", false);

              case 4:
                _context4.next = 6;
                return this.getBlockWrapper(predictedBlock.number - 1);

              case 6:
                previousBlock = _context4.sent;

                if (!(blockTime >= date && previousBlock.timestamp < date)) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return", true);

              case 9:
                _context4.next = 18;
                break;

              case 11:
                if (!(blockTime >= date)) {
                  _context4.next = 13;
                  break;
                }

                return _context4.abrupt("return", false);

              case 13:
                _context4.next = 15;
                return this.getBlockWrapper(predictedBlock.number + 1);

              case 15:
                nextBlock = _context4.sent;

                if (!(blockTime < date && nextBlock.timestamp >= date)) {
                  _context4.next = 18;
                  break;
                }

                return _context4.abrupt("return", true);

              case 18:
                return _context4.abrupt("return", false);

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function isBetterBlock(_x5, _x6, _x7) {
        return _isBetterBlock.apply(this, arguments);
      }

      return isBetterBlock;
    }()
  }, {
    key: "getNextBlock",
    value: function getNextBlock(date, currentBlock, skip) {
      var nextBlock = currentBlock + skip;

      if (this.checkedBlocks[date].includes(nextBlock)) {
        return this.getNextBlock(date, currentBlock, skip < 0 ? ++skip : --skip);
      }

      this.checkedBlocks[date].push(nextBlock);
      return nextBlock;
    }
  }, {
    key: "getBlockWrapper",
    value: function () {
      var _getBlockWrapper = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(block) {
        var fetchedBlock, _yield$this$requestMa, timestamp;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.saveBlocks) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 3;
                return this.requestManager.eth_getBlockByNumber(block, false);

              case 3:
                fetchedBlock = _context5.sent;
                return _context5.abrupt("return", {
                  number: (0, eth_connect_1.toBigNumber)(fetchedBlock.number).toNumber(),
                  timestamp: (0, eth_connect_1.toBigNumber)(fetchedBlock.timestamp).toNumber()
                });

              case 5:
                if (!this.savedBlocks[block.toString()]) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", this.savedBlocks[block]);

              case 7:
                if (!(typeof block === 'number' && this.savedBlocks['latest'] && this.savedBlocks['latest'].number <= block)) {
                  _context5.next = 9;
                  break;
                }

                return _context5.abrupt("return", this.savedBlocks['latest']);

              case 9:
                _context5.next = 11;
                return this.requestManager.eth_getBlockByNumber(block, false);

              case 11:
                _yield$this$requestMa = _context5.sent;
                timestamp = _yield$this$requestMa.timestamp;
                _context5.t0 = (0, eth_connect_1.toBigNumber);

                if (!(block === 'latest')) {
                  _context5.next = 20;
                  break;
                }

                _context5.next = 17;
                return this.requestManager.eth_blockNumber();

              case 17:
                _context5.t1 = _context5.sent;
                _context5.next = 21;
                break;

              case 20:
                _context5.t1 = block;

              case 21:
                _context5.t2 = _context5.t1;
                _context5.t3 = (0, _context5.t0)(_context5.t2).toNumber();
                _context5.t4 = (0, eth_connect_1.toBigNumber)(timestamp).toNumber();
                this.savedBlocks[block.toString()] = {
                  number: _context5.t3,
                  timestamp: _context5.t4
                };
                this.requests++;
                return _context5.abrupt("return", this.savedBlocks[block.toString()]);

              case 27:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getBlockWrapper(_x8) {
        return _getBlockWrapper.apply(this, arguments);
      }

      return getBlockWrapper;
    }()
  }]);

  return Blocks;
}();

exports.default = Blocks;